import React from 'react'
import styled from 'styled-components'

const RegisterFormTitle = styled.div`
  color: var(--red-bnz);
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  transition: color 0.3s ease;
`

const RegisterFormTitleWrapper = props => {
  return (
    <RegisterFormTitle style={props.style}>
      {props.children}
    </RegisterFormTitle>
  )
}

export default RegisterFormTitleWrapper